import { styled as o } from "styled-components";
import { Theme as i } from "../../../../styles/themes/index.js";
const e = o.div`
  display: grid;
  width: 100%;
  position: relative;
  color: rgb(${i.colors.Juliet});
`;
export {
  e as Container
};
